import React from 'react';
import { brandAssets } from '../config/brandAssets';
import './SplashScreen.css';

export default function SplashScreen() {
  return (
    <div className="app-splash" role="status" aria-live="polite" aria-label="Cargando Pulsora">
      <img src={brandAssets.app.splashLight} alt="Pulsora" />
      <span className="visually-hidden">Cargando Pulsora…</span>
    </div>
  );
}
